import React from "react";
// Swap this file to change the portrait. Best: a transparent PNG/WebP cutout,
// cropped tight, roughly 1200px+ tall.
import KR8S from "../assets/kroosPN.png";
import "../styles/Hero.css";

const STATS = [
  { value: "6", label: "Champions League titles" },
  { value: "2014", label: "World Cup winner" },
  { value: "10", label: "Years at Real Madrid" },
];

function Hero() {
  return (
    <header className="hero" id="home">
      <div className="hero__inner">
        <div className="hero__text">
          <h1 className="hero__title">
            <span>Toni</span>
            <span>Kroos</span>
          </h1>
          <div className="hero__flag" aria-hidden="true" />
          <p className="hero__subtitle">From Greifswald to Glory</p>
          <p className="hero__description">
            A maestro of midfield, whose consistency never wavered. Season after
            season, excellence was simply the standard.
          </p>

          <dl className="hero__stats">
            {STATS.map(({ value, label }) => (
              <div className="hero__stat" key={label}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="hero__visual">
          <span className="hero__ghost" aria-hidden="true">
            8
          </span>
          <img
            src={KR8S}
            alt="Toni Kroos"
            className="hero__img"
            fetchpriority="high"
            decoding="async"
          />
        </div>
      </div>
    </header>
  );
}

export default Hero;
